module.exports = __webpack_public_path__ + "static/alexanderShpilka-76de77922f71fc950808361989b66f32.png";